import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import FlowAPI from '../../api/flows';

export const state = {
  records: [],
  recordsAll: [],
  typeBot:{},
  totalCount:0,
  published: false,
  uiFlags: {
    isFetching: false,
    isFetchingAll: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getFlows($state) {
    return $state.records;
  },
  getAllFlows($state) {
    return $state.recordsAll;
  },

  getTotalCount($state){
    return $state.totalCount;
  },
  getVerifiedFlows($state) {
    return $state.records.filter(record => record.confirmed);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },

  getFlowStatus($state) {
    let status = {
      online: $state.records.filter(
        flow => flow.availability_status === 'online'
      ).length,
      busy: $state.records.filter(flow => flow.availability_status === 'busy')
        .length,
      offline: $state.records.filter(
        flow => flow.availability_status === 'offline'
      ).length,
    };
    return status;
  },
  getTypeBotData($state){
    return $state.typeBot;
  }
};

export const actions = {
  get: async ({ commit },params) => {
    commit(types.default.SET_FLOW_FETCHING_STATUS, true);
    try {
      const response = await FlowAPI.get(params);
      commit(types.default.SET_FLOW_FETCHING_STATUS, false);
      commit(types.default.SET_FLOWS, response.data);
      commit("setTotalCount",response.headers["count"] )
    } catch (error) {
      commit(types.default.SET_FLOW_FETCHING_STATUS, false);
    }
  },
  getAll: async ({ commit },params) => {
    commit(types.default.SET_FLOW_ALL_FETCHING_STATUS, true);
    try {
      const response = await FlowAPI.getAll(params);
      commit(types.default.SET_FLOW_ALL_FETCHING_STATUS, false);
      commit("setAllFlows", response.data);
      
    } catch (error) {
      commit(types.default.SET_FLOW_ALL_FETCHING_STATUS, false);
    }
  },
  create: async ({ commit }, flowInfo) => {
    commit(types.default.SET_FLOW_CREATING_STATUS, true);
    try {
      const response = await FlowAPI.create(flowInfo);
      commit(types.default.ADD_FLOW, response.data);
      commit(types.default.SET_FLOW_CREATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_FLOW_CREATING_STATUS, false);
      throw error;
    }
  },
  clone: async ({ commit }, flowInfo) => {
    commit(types.default.SET_FLOW_CREATING_STATUS, true);
    try {
      const response = await FlowAPI.clone(flowInfo);
      commit(types.default.ADD_FLOW, response.data);
      commit(types.default.SET_FLOW_CREATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_FLOW_CREATING_STATUS, false);
      throw error;
    }
  },
  update: async ({ commit }, { id, ...flowParams }) => {
    commit(types.default.SET_FLOW_UPDATING_STATUS, true);
    try {
      const response = await FlowAPI.update(id, flowParams);
      commit(types.default.EDIT_FLOW, response.data);
      commit(types.default.SET_FLOW_UPDATING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_FLOW_UPDATING_STATUS, false);
      throw new Error(error);
    }
  },
  updateSingleFlowPresence: ({ commit }, { id, availabilityStatus }) => {
    commit(types.default.UPDATE_SINGLE_FLOW_PRESENCE, {
      id,
      availabilityStatus,
    });
  },
  updatePresence: async ({ commit }, data) => {
    commit(types.default.UPDATE_FLOWS_PRESENCE, data);
  },
  delete: async ({ commit }, typebotId) => {
    commit(types.default.SET_FLOW_DELETING_STATUS, true);
    try {
      await FlowAPI.delete(typebotId);
      commit(types.default.DELETE_FLOW, typebotId);
      commit(types.default.SET_FLOW_DELETING_STATUS, false);
    } catch (error) {
      commit(types.default.SET_FLOW_DELETING_STATUS, false);
      throw new Error(error);
    }
  },
  getTypoBot:async ({ commit }) => {
    commit(types.default.SET_FLOW_FETCHING_STATUS, true);
    try {
      const response = await FlowAPI.getTypeBotToken();
      commit(types.default.SET_FLOW_FETCHING_STATUS, false);
      commit('setTypoBotToken', response.data);
    } catch (error) {
      commit(types.default.SET_FLOW_FETCHING_STATUS, false);
    }
  },
  publish:async ({ commit }, flowId) => {
    commit(types.default.SET_FLOW_UPDATING_STATUS, true);
    try {
      const response = await FlowAPI.publish(flowId);
      commit(types.default.SET_FLOW_UPDATING_STATUS, false);
      commit('publishFlow', response.data);
    } catch (error) {
      commit(types.default.SET_FLOW_UPDATING_STATUS, false);
    }
  }
};

export const mutations = {

  setTypoBotToken($state, data){
    $state.typeBot = data
  }, 

  publishFlow($state, data){
    $state.published = true
  }, 

  setTotalCount($state, count)
  {
    if(count){
    $state.totalCount = parseInt(count)
    }else{
      $state.totalCount=0
    }
  }, 

  setAllFlows($state, data){
    $state.recordsAll = data;
  },

  [types.default.SET_FLOW_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetching = status;
  },
  [types.default.SET_FLOW_ALL_FETCHING_STATUS]($state, status) {
    $state.uiFlags.isFetchingAll = status;
  },
  [types.default.SET_FLOW_CREATING_STATUS]($state, status) {
    $state.uiFlags.isCreating = status;
  },
  [types.default.SET_FLOW_UPDATING_STATUS]($state, status) {
    $state.uiFlags.isUpdating = status;
  },
  [types.default.SET_FLOW_DELETING_STATUS]($state, status) {
    $state.uiFlags.isDeleting = status;
  },

  [types.default.SET_FLOWS]: MutationHelpers.set,
  [types.default.SET_ALL_FLOWS]: MutationHelpers.set,
  [types.default.ADD_FLOW]: MutationHelpers.create,
  [types.default.EDIT_FLOW]: MutationHelpers.update,
  [types.default.DELETE_FLOW]: MutationHelpers.destroy,
  [types.default.UPDATE_FLOWS_PRESENCE]: MutationHelpers.updatePresence,
  [types.default.UPDATE_SINGLE_FLOW_PRESENCE]: (
    $state,
    { id, availabilityStatus }
  ) =>
    MutationHelpers.updateSingleRecordPresence($state.records, {
      id,
      availabilityStatus,
    }),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
